export default __webpack_public_path__ + "static/media/homeScene_2.de7cf28e.png";